import * as React from "react";
const SvgLeadIconChevron = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 50 32", ...props }, /* @__PURE__ */ React.createElement("polygon", { strokeWidth: 2, fillRule: "nonzero", points: "1,1 9,16 1,31 41,31 49,16 41,1", strokeLinejoin: "round" }));
export default SvgLeadIconChevron;
